var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabView"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:_vm.active.text === item.text ? 'active' : '',on:{"click":function($event){return _vm.onTab(item)}}},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-017e32d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tab.vue
// module id = null
// module chunks = 